(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@arkas/core"] = factory();
	else
		root["@arkas/core"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/framework/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/framework/async/deferred.js":
/*!*****************************************!*\
  !*** ./src/framework/async/deferred.js ***!
  \*****************************************/
/*! exports provided: Deferred */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Deferred", function() { return Deferred; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);


var Deferred = function Deferred() {
  var _this = this;

  _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Deferred);

  _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "isPending", true);

  _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "isFulfilled", false);

  _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "isRejected", false);

  this.promise = new Promise(function (resolve, reject) {
    _this.reject = function (err) {
      _this.isRejected = true;
      _this.isPending = false;
      reject(err);
    };

    _this.resolve = function (data) {
      _this.isFulfilled = true;
      _this.isPending = false;
      resolve(data);
    };
  });
};

/***/ }),

/***/ "./src/framework/async/fetch.js":
/*!**************************************!*\
  !*** ./src/framework/async/fetch.js ***!
  \**************************************/
/*! exports provided: default, getAsync, postAsync, putAsync, deleteAsync */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAsync", function() { return getAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postAsync", function() { return postAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "putAsync", function() { return putAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAsync", function() { return deleteAsync; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils */ "./src/framework/utils/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");
/* harmony import */ var _headers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./headers */ "./src/framework/async/headers.js");
/* harmony import */ var _paramsSerializer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./paramsSerializer */ "./src/framework/async/paramsSerializer.js");






var RequestMethod = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete"
};
/**
 * Request Options
 * @typedef {Object} RequestOptions
 * @property {string} url Fetch url
 * @property {string} method Http verb
 * @property {boolean} byPassErrorInterceptor Skip error interceptor
 */
//#region Private methods

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */

var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);
  error.response = response;
  throw error;
};
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */


var parseJSON = function parseJSON(response) {
  //204 No Content 205 Reset Content
  if (response.status === 204 || response.status === 205) {
    return null;
  }

  return response.data;
};
/**
 * Create generic request
 *
 * @param {string} method Http request verb - GET,POST,PUT,DELETE
 * @param {(RequestOptions|...string)} args Request options or url and payload  {@link RequestOptions}
 *
 * @returns {Promise} Returned promise
 */


var makeRequest = function makeRequest(method) {
  //validations
  Object(_utils__WEBPACK_IMPORTED_MODULE_2__["validate"])([[!method, "method is missing"], [!(arguments.length <= 1 ? 0 : arguments.length - 1), "fetch params is missing"]]); //Configs

  var timeout = _config__WEBPACK_IMPORTED_MODULE_3__["config"].get("request.requestTimeout");
  var options;

  if (Object(_utils__WEBPACK_IMPORTED_MODULE_2__["isString"])(arguments.length <= 1 ? undefined : arguments[1])) {
    options = {
      url: arguments.length <= 1 ? undefined : arguments[1]
    };
    options[method === RequestMethod.GET ? "params" : "data"] = arguments.length <= 2 ? undefined : arguments[2];
    options.headers = arguments.length <= 3 ? undefined : arguments[3];
  } else {
    options = arguments.length <= 1 ? undefined : arguments[1];
  } //remote request


  return axios__WEBPACK_IMPORTED_MODULE_1___default()({
    method: method,
    url: options.url,
    data: options.data,
    headers: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, Object(_headers__WEBPACK_IMPORTED_MODULE_4__["default"])(), options.headers),
    params: options.params,
    paramsSerializer: _paramsSerializer__WEBPACK_IMPORTED_MODULE_5__["default"],
    timeout: options.timeout || timeout,
    responseType: options.responseType,
    byPassErrorInterceptor: options.byPassErrorInterceptor
  }).then(checkStatus).then(parseJSON);
}; //#endregion
//#region Exported Methods

/**
 * Make GET request
 *
 * @param {(RequestOptions|...string)} args RequestOptions or url nad payload
 */


var getAsync = function getAsync() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return makeRequest.apply(void 0, [RequestMethod.GET].concat(args));
};
/**
 * Make POST request
 *
 * @param {(RequestOptions|...string)} args RequestOptions or url and payload
 */


var postAsync = function postAsync() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return makeRequest.apply(void 0, [RequestMethod.POST].concat(args));
};
/**
 * Make PUT request
 *
 * @param {(RequestOptions|...string)} args RequestOptions or url nad payload
 */


var putAsync = function putAsync() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return makeRequest.apply(void 0, [RequestMethod.PUT].concat(args));
};
/**
 * Make DELETE request
 *
 * @param {(RequestOptions|...string)} args RequestOptions or url nad payload
 */


var deleteAsync = function deleteAsync() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return makeRequest.apply(void 0, [RequestMethod.DELETE].concat(args));
};
/**
 * Generic async fetch
 */


function fetch() {} //#endregion



/***/ }),

/***/ "./src/framework/async/headers.js":
/*!****************************************!*\
  !*** ./src/framework/async/headers.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils */ "./src/framework/utils/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");



/**
 * Default requrest headers
 * @returns Headers object
 */

/* harmony default export */ __webpack_exports__["default"] = (function () {
  var correlationIdHeaderName = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("request.correlationIdHeaderName"),
      generateCorrelationId = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("request.generateCorrelationId");

  var headers = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    "If-Modified-Since": "Mon, 26 Jul 1997 05:00:00 GMT"
  }, correlationIdHeaderName, generateCorrelationId && Object(_utils__WEBPACK_IMPORTED_MODULE_1__["uuidv4"])());

  return headers;
});

/***/ }),

/***/ "./src/framework/async/index.js":
/*!**************************************!*\
  !*** ./src/framework/async/index.js ***!
  \**************************************/
/*! exports provided: Deferred, getAsync, postAsync, putAsync, deleteAsync */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./fetch */ "./src/framework/async/fetch.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getAsync", function() { return _fetch__WEBPACK_IMPORTED_MODULE_0__["getAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "postAsync", function() { return _fetch__WEBPACK_IMPORTED_MODULE_0__["postAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "putAsync", function() { return _fetch__WEBPACK_IMPORTED_MODULE_0__["putAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "deleteAsync", function() { return _fetch__WEBPACK_IMPORTED_MODULE_0__["deleteAsync"]; });

/* harmony import */ var _deferred__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./deferred */ "./src/framework/async/deferred.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Deferred", function() { return _deferred__WEBPACK_IMPORTED_MODULE_1__["Deferred"]; });




/***/ }),

/***/ "./src/framework/async/paramsSerializer.js":
/*!*************************************************!*\
  !*** ./src/framework/async/paramsSerializer.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "@babel/runtime/helpers/typeof");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);


var parseParams = function parseParams(params) {
  var keys = Object.keys(params);
  var options = "";
  keys.forEach(function (key) {
    //ignore undefined and null
    if (!params[key]) return;
    var isParamTypeObject = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(params[key]) === "object";

    if (!isParamTypeObject) {
      //string ,number,boolean
      options += "".concat(key, "=").concat(params[key], "&");
    } else {
      //array
      if (Array.isArray(params[key])) {
        params[key].forEach(function (element) {
          options += "".concat(key, "=").concat(element, "&");
        });
      } else {
        //run toJSON function if available foı moment objects
        //https://stackoverflow.com/a/14991571/1016147
        var toJSONFn = params[key].toJSON;

        if (typeof toJSONFn === "function") {
          options += "".concat(key, "=").concat(toJSONFn.call(params[key]), "&");
        }
      }
    }
  });
  return options ? options.slice(0, -1) : options;
};

/* harmony default export */ __webpack_exports__["default"] = (parseParams);

/***/ }),

/***/ "./src/framework/auth/apiMKey.js":
/*!***************************************!*\
  !*** ./src/framework/auth/apiMKey.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Add predefined gateway token to request header
 *
 * @param {*} headers Request header
 */

/* harmony default export */ __webpack_exports__["default"] = (function (headers) {
  if (_config__WEBPACK_IMPORTED_MODULE_0__["config"].get("oauth.apiMKey")) {
    var tokenHeaderName = _config__WEBPACK_IMPORTED_MODULE_0__["config"].get("oauth.apiMKeyHeaderName");

    if (!headers.common[tokenHeaderName]) {
      axios__WEBPACK_IMPORTED_MODULE_1___default.a.defaults.headers.common[tokenHeaderName] = headers[tokenHeaderName] = _config__WEBPACK_IMPORTED_MODULE_0__["config"].get("oauth.apiMKey");
    }
  }
});

/***/ }),

/***/ "./src/framework/auth/getToken.js":
/*!****************************************!*\
  !*** ./src/framework/auth/getToken.js ***!
  \****************************************/
/*! exports provided: fetchToken, addTokenReceived, isApiCall */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchToken", function() { return fetchToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTokenReceived", function() { return addTokenReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isApiCall", function() { return isApiCall; });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../async */ "./src/framework/async/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");



var tokenRecievedCallbacks = [];
var tokenPromise;
/**
 * Add token callback
 *
 * @param {Function} cb Callback to be called when token is recevied
 * @returns {Function} Remove callback
 */

var addTokenReceived = function addTokenReceived(cb) {
  tokenRecievedCallbacks.push(cb);
  return function () {
    var index = tokenRecievedCallbacks.indexOf(cb);
    index > -1 && tokenRecievedCallbacks.splice(index, 1);
  };
};
/**
 * Request token end point
 */


function fetchToken() {
  var tokenEndPoint = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("oauth.tokenEndPoint");
  var Cookie = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("oauth.federatedCookieForSSR");
  if (!tokenEndPoint) return Promise.resolve();
  return tokenPromise || (tokenPromise = Object(_async__WEBPACK_IMPORTED_MODULE_1__["getAsync"])({
    url: tokenEndPoint,
    headers: Cookie && {
      Cookie: Cookie
    }
  }).then(function (token) {
    //set jwt bearer header
    axios__WEBPACK_IMPORTED_MODULE_0___default.a.defaults.headers.common.Authorization = "Bearer ".concat(token); //call cb's

    tokenRecievedCallbacks.forEach(function (cb) {
      return cb(token);
    });
    return token;
  }).finally(function () {
    tokenPromise = null;
  }));
}
/**
 * Return if url host is baseUrl
 *
 * @param {string} url Url to check
 */


function isApiCall(url) {
  var baseServiceUrl = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("baseServiceUrl");
  var tokenEndPoint = _config__WEBPACK_IMPORTED_MODULE_2__["config"].get("oauth.tokenEndPoint");
  return url && url !== tokenEndPoint && url.includes(baseServiceUrl);
}



/***/ }),

/***/ "./src/framework/auth/index.js":
/*!*************************************!*\
  !*** ./src/framework/auth/index.js ***!
  \*************************************/
/*! exports provided: addTokenReceived */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _requestInterceptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./requestInterceptor */ "./src/framework/auth/requestInterceptor.js");
/* harmony import */ var _responseInterceptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./responseInterceptor */ "./src/framework/auth/responseInterceptor.js");
/* harmony import */ var _getToken__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getToken */ "./src/framework/auth/getToken.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addTokenReceived", function() { return _getToken__WEBPACK_IMPORTED_MODULE_2__["addTokenReceived"]; });





/***/ }),

/***/ "./src/framework/auth/requestInterceptor.js":
/*!**************************************************!*\
  !*** ./src/framework/auth/requestInterceptor.js ***!
  \**************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _getToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./getToken */ "./src/framework/auth/getToken.js");
/* harmony import */ var _apiMKey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./apiMKey */ "./src/framework/auth/apiMKey.js");




var request = function request(requestConfig) {
  if (!Object(_getToken__WEBPACK_IMPORTED_MODULE_1__["isApiCall"])(requestConfig.url)) return requestConfig; //gateway token

  Object(_apiMKey__WEBPACK_IMPORTED_MODULE_2__["default"])(requestConfig.headers); //jwt token

  if (!requestConfig.headers.common.Authorization) {
    return Object(_getToken__WEBPACK_IMPORTED_MODULE_1__["fetchToken"])().then(function (token) {
      if (token) requestConfig.headers.Authorization = "Bearer ".concat(token);
      return requestConfig;
    });
  }

  return requestConfig;
};

axios__WEBPACK_IMPORTED_MODULE_0___default.a.interceptors.request.use(request);

/***/ }),

/***/ "./src/framework/auth/responseInterceptor.js":
/*!***************************************************!*\
  !*** ./src/framework/auth/responseInterceptor.js ***!
  \***************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _retryQueue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./retryQueue */ "./src/framework/auth/retryQueue.js");
/* harmony import */ var _getToken__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./getToken */ "./src/framework/auth/getToken.js");
/* harmony import */ var _async_deferred__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../async/deferred */ "./src/framework/async/deferred.js");





var interceptor401 = function interceptor401(error) {
  var response = error.response;

  if (response && response.status === 401 && Object(_getToken__WEBPACK_IMPORTED_MODULE_2__["isApiCall"])(response.config.url)) {
    //store unauthorized request's config
    var defer = new _async_deferred__WEBPACK_IMPORTED_MODULE_3__["Deferred"]();
    Object(_retryQueue__WEBPACK_IMPORTED_MODULE_1__["addQueue"])(response, defer); //get token

    Object(_getToken__WEBPACK_IMPORTED_MODULE_2__["fetchToken"])().then(function (token) {
      if (!token) {
        defer.resolve();
      } else {
        Object(_retryQueue__WEBPACK_IMPORTED_MODULE_1__["retryAll"])(function (config) {
          config.headers.Authorization = "Bearer ".concat(token);
          return config;
        });
      }
    });
    return defer.promise;
  }

  return Promise.reject(error);
};

axios__WEBPACK_IMPORTED_MODULE_0___default.a.interceptors.response.use(null, interceptor401);

/***/ }),

/***/ "./src/framework/auth/retryQueue.js":
/*!******************************************!*\
  !*** ./src/framework/auth/retryQueue.js ***!
  \******************************************/
/*! exports provided: addQueue, retryAll */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQueue", function() { return addQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retryAll", function() { return retryAll; });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

var buffer = [];
/**
 * Retry request with token
 *
 * @param {*} config Request config
 * @param {*} deferred Promise
 */

function retryHttpRequest(config, deferred) {
  function successCallback(response) {
    deferred.resolve(response);
  }

  function errorCallback(response) {
    deferred.reject(response);
  }

  axios__WEBPACK_IMPORTED_MODULE_0___default()(config).then(successCallback, errorCallback);
}
/**
 * Add request to queue
 *
 * @param {*} response Response
 * @param {*} deferred Promise
 */


function addQueue(response, deferred) {
  buffer.push({
    response: response,
    deferred: deferred
  });
}
/**
 * Retry all pending requests
 *
 * @param {Function} updater Callback to add token
 */


function retryAll(updater) {
  for (var i = 0; i < buffer.length; ++i) {
    retryHttpRequest(updater(buffer[i].response.config), buffer[i].deferred);
  }

  buffer = [];
}



/***/ }),

/***/ "./src/framework/config/config.js":
/*!****************************************!*\
  !*** ./src/framework/config/config.js ***!
  \****************************************/
/*! exports provided: config, setConfig */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setConfig", function() { return setConfig; });
/* harmony import */ var _defaultConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defaultConfig */ "./src/framework/config/defaultConfig.js");
/* harmony import */ var _configFactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./configFactory */ "./src/framework/config/configFactory.js");


/**
 * MainConfig
 * @typedef {Object} Main configuration
 * @property {string} baseServiceUrl API gateway baseURL for all outgoing requests
 */

/**
 * @type {MainConfig} Create config instance
 */

var config = Object(_configFactory__WEBPACK_IMPORTED_MODULE_1__["createConfig"])(_defaultConfig__WEBPACK_IMPORTED_MODULE_0__["default"]);
/**
 * Set config.Each call of setConfig will merge with existing config if any
 *
 * @param {MainConfig} initialConfig App settings
 */

var setConfig = function setConfig(userInitialConfig) {
  config.init(userInitialConfig);
};

/***/ }),

/***/ "./src/framework/config/configFactory.js":
/*!***********************************************!*\
  !*** ./src/framework/config/configFactory.js ***!
  \***********************************************/
/*! exports provided: withConfig, createConfig */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withConfig", function() { return withConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createConfig", function() { return createConfig; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../log */ "./src/framework/log/index.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils */ "./src/framework/utils/index.js");



var withConfig = function withConfig(initialConfig) {
  return function (o) {
    var config = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["merge"])({}, initialConfig);
    var baseConfig = {
      /**
       * Return value of given key
       *
       * @param {string} key Key path
       */
      get: function get(key, defaultValue) {
        var value = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["getObj"])(key, config);
        return value == undefined ? defaultValue : value;
      },

      /**
       * Set config
       *
       * @param {string} key Property key
       * @param {*} value Property value
       */
      set: function set(key, value) {
        Object(_utils__WEBPACK_IMPORTED_MODULE_2__["setObj"])(key, value, config);
      },

      /**
       * Merge config
       *
       * @param {MainConfig} userConfig App configuration
       */
      init: function init(userConfig) {
        config = Object(_utils__WEBPACK_IMPORTED_MODULE_2__["merge"])(config, userConfig);
      },

      /**
       * Returns all config
       */
      all: function all() {
        return config;
      }
    };
    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, o, baseConfig);
  };
};
/**
 * Create configuratio object
 *
 * @param {MainConfig} initialConfig App config
 * @returns {Function} Returns factory object
 */

var createConfig = function createConfig(initialConfig) {
  return Object(_utils__WEBPACK_IMPORTED_MODULE_2__["pipe"])(_log__WEBPACK_IMPORTED_MODULE_1__["logger"], withConfig(initialConfig))({});
};

/***/ }),

/***/ "./src/framework/config/constants.js":
/*!*******************************************!*\
  !*** ./src/framework/config/constants.js ***!
  \*******************************************/
/*! exports provided: constants */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return constants; });
var constants = {
  rcconfigName: "@arkas",
  oauth: {
    TOKEN_ENDPOINT: "/account/token",
    UNAUTHORIZED_ROUTE_URL: "./unauthorized",
    APIMKEY_HEADER_NAME: "Ocp-Apim-Subscription-Key"
  },
  signalr: {
    url: "/"
  },
  loadable: {
    LOADING_COMPONENT: function LOADING_COMPONENT() {
      return null;
    },
    DELAY: 200,
    TIMEOUT: 10
  },
  request: {
    API_PREFIX: "api",
    PAGING_DEFAULT_PAGE_SIZE: 25,
    REQUEST_TIME_OUT: 4000,
    CORRELATION_ID_HEADER_NAME: "CorrelationId"
  },
  server: {
    RESPONSE_JSON_DATA_NAME: "data",
    ACTION_NAME_LIST: "getlist",
    ACTION_NAME_PAGED_LIST: "getpagedlist",
    ACTION_NAME_GET_BY_ID: "getmodelbyid",
    ACTION_NAME_SAVE: "savechanges",
    ACTION_NAME_DELETE: "deletemodelbyid"
  },
  i18n: {
    DEFAULT_LANG: "en-US",
    CULTURE_HEADER_NAME: "Culture",
    DEFAULT_UNKNOWN_RESOURCE: "Resource not found"
  },
  models: {
    LANG_MODEL_NAME: "langModel",
    DOMAIN_TASK_MODEL_NAME: "domainTasks",
    GLOBALS_MODEL_NAME: "globals",
    ERROR_MODEL_NAME: "errors",
    LOADING_MODEL_NAME: "loading"
  }
};


/***/ }),

/***/ "./src/framework/config/defaultConfig.js":
/*!***********************************************!*\
  !*** ./src/framework/config/defaultConfig.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */ "./src/framework/config/constants.js");

/**
 * Default config
 */

var defaultConfig = {
  isSSR: false,
  signalr: {
    url: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].signalr.URL
  },
  oauth: {
    unAuthorizedRouteUrl: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].oauth.UNAUTHORIZED_ROUTE_URL,
    permissions: {},
    apiMKeyHeaderName: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].oauth.APIMKEY_HEADER_NAME
  },
  request: {
    pagingDefaultPageSize: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].request.PAGING_DEFAULT_PAGE_SIZE,
    requestTimeout: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].request.REQUEST_TIME_OUT,
    correlationIdHeaderName: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].request.CORRELATION_ID_HEADER_NAME,
    generateCorrelationId: true,
    defaultApiPrefix: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].request.API_PREFIX
  },
  response: {
    responseJsonDataName: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.RESPONSE_JSON_DATA_NAME
  },
  crudActionNames: {
    delete: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.ACTION_NAME_DELETE,
    getById: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.ACTION_NAME_GET_BY_ID,
    getList: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.ACTION_NAME_LIST,
    getPagedList: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.ACTION_NAME_PAGED_LIST,
    save: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].server.ACTION_NAME_SAVE
  },
  loadable: {
    defaultLoadingComponent: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].loadable.LOADING_COMPONENT,
    delay: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].loadable.DELAY,
    timeout: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].loadable.TIMEOUT
  },
  i18n: {
    currentCultureHeaderName: _constants__WEBPACK_IMPORTED_MODULE_0__["constants"].i18n.CULTURE_HEADER_NAME
  }
};
/* harmony default export */ __webpack_exports__["default"] = (defaultConfig);

/***/ }),

/***/ "./src/framework/config/index.js":
/*!***************************************!*\
  !*** ./src/framework/config/index.js ***!
  \***************************************/
/*! exports provided: config, setConfig, constants */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config */ "./src/framework/config/config.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "config", function() { return _config__WEBPACK_IMPORTED_MODULE_0__["config"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setConfig", function() { return _config__WEBPACK_IMPORTED_MODULE_0__["setConfig"]; });

/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/framework/config/constants.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return _constants__WEBPACK_IMPORTED_MODULE_1__["constants"]; });




/***/ }),

/***/ "./src/framework/decorators/autobind.js":
/*!**********************************************!*\
  !*** ./src/framework/decorators/autobind.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return autobind; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "@babel/runtime/helpers/typeof");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);

var excludedReactMethods = ["componentWillMount", "UNSAFE_componentWillMount", "render", "getSnapshotBeforeUpdate", "componentDidMount", "componentWillReceiveProps", "UNSAFE_componentWillReceiveProps", "shouldComponentUpdate", "componentWillUpdate", "UNSAFE_componentWillUpdate", "componentDidUpdate", "componentWillUnmount", "componentDidCatch", "setState", "forceUpdate"];
function autobind() {
  if (arguments.length === 1) {
    return boundClass.apply(void 0, arguments);
  } else {
    return boundMethod.apply(void 0, arguments);
  }
}

function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys; // Use Reflect if exists

  if (typeof Reflect !== "undefined" && typeof Reflect.ownKeys === "function") {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype); // use symbols if support is provided

    if (typeof Object.getOwnPropertySymbols === "function") {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === "constructor" || excludedReactMethods.indexOf(key) > -1) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key); // Only methods need binding

    if (typeof descriptor.value === "function") {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}

function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== "function") {
    throw new Error("@autobind decorator can only be applied to methods not: ".concat(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(fn)));
  } // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.


  var definingProperty = false;
  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key) || typeof fn !== "function") {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        configurable: true,
        get: function get() {
          return boundFn;
        },
        set: function set(value) {
          fn = value;
          delete this[key];
        }
      });
      definingProperty = false;
      return boundFn;
    },
    set: function set(value) {
      fn = value;
    }
  };
}

/***/ }),

/***/ "./src/framework/index.js":
/*!********************************!*\
  !*** ./src/framework/index.js ***!
  \********************************/
/*! exports provided: addTokenReceived, getAsync, postAsync, deleteAsync, putAsync, config, model, dispatch, getState, utils, ConnectedRouter, PrivateRoute, replace, push, go, goBack, setBackAction, ErrorBoundary, serverRender, Hub, autobind, getPersistor, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./auth */ "./src/framework/auth/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addTokenReceived", function() { return _auth__WEBPACK_IMPORTED_MODULE_0__["addTokenReceived"]; });

/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./config */ "./src/framework/config/index.js");
/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./async */ "./src/framework/async/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getAsync", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["getAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "postAsync", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["postAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "deleteAsync", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["deleteAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "putAsync", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["putAsync"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "config", function() { return _config__WEBPACK_IMPORTED_MODULE_1__["config"]; });

/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./state */ "./src/framework/state/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "model", function() { return _state__WEBPACK_IMPORTED_MODULE_3__["model"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return _state__WEBPACK_IMPORTED_MODULE_3__["dispatch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getState", function() { return _state__WEBPACK_IMPORTED_MODULE_3__["getState"]; });

/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/framework/utils/index.js");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return _utils__WEBPACK_IMPORTED_MODULE_4__; });
/* harmony import */ var _routing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./routing */ "./src/framework/routing/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["ConnectedRouter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PrivateRoute", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["PrivateRoute"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["replace"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "push", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["push"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "go", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["go"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["goBack"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setBackAction", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["setBackAction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return _routing__WEBPACK_IMPORTED_MODULE_5__["ErrorBoundary"]; });

/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ssr */ "./src/framework/ssr/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "serverRender", function() { return _ssr__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _signalr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./signalr */ "./src/framework/signalr/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return _signalr__WEBPACK_IMPORTED_MODULE_7__["Hub"]; });

/* harmony import */ var _decorators_autobind__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./decorators/autobind */ "./src/framework/decorators/autobind.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "autobind", function() { return _decorators_autobind__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _state_plugins_persistPlugin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./state/plugins/persistPlugin */ "./src/framework/state/plugins/persistPlugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPersistor", function() { return _state_plugins_persistPlugin__WEBPACK_IMPORTED_MODULE_9__["getPersistor"]; });














/**
 * Init the app with provided settings
 * @param {App wide configuration} appConfig
 */

/* harmony default export */ __webpack_exports__["default"] = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$appConfig = _ref.appConfig,
      appConfig = _ref$appConfig === void 0 ? {} : _ref$appConfig,
      _ref$stateConfig = _ref.stateConfig,
      stateConfig = _ref$stateConfig === void 0 ? {} : _ref$stateConfig;

  //set config
  Object(_config__WEBPACK_IMPORTED_MODULE_1__["setConfig"])(appConfig); //init redux

  var store = Object(_state__WEBPACK_IMPORTED_MODULE_3__["default"])(stateConfig); //return store

  return store;
});

/***/ }),

/***/ "./src/framework/log/index.js":
/*!************************************!*\
  !*** ./src/framework/log/index.js ***!
  \************************************/
/*! exports provided: withLogging, logger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _logFactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./logFactory */ "./src/framework/log/logFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withLogging", function() { return _logFactory__WEBPACK_IMPORTED_MODULE_0__["withLogging"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logger", function() { return _logFactory__WEBPACK_IMPORTED_MODULE_0__["logger"]; });



/***/ }),

/***/ "./src/framework/log/logFactory.js":
/*!*****************************************!*\
  !*** ./src/framework/log/logFactory.js ***!
  \*****************************************/
/*! exports provided: withLogging, logger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withLogging", function() { return withLogging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logger", function() { return logger; });
var withLogging = function withLogging(logger) {
  return function (o) {
    return Object.assign({}, o, {
      log: function log(text) {
        if (true) {
          logger(text);
        }
      }
    });
  };
};
/*eslint no-console: ["warn", { allow: ["warn","error"] }] */

var consoleLogger = console.log.bind(console);
var logger = withLogging(consoleLogger);

/***/ }),

/***/ "./src/framework/routing/ErrorBoundary.js":
/*!************************************************!*\
  !*** ./src/framework/routing/ErrorBoundary.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "@babel/runtime/helpers/possibleConstructorReturn");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "@babel/runtime/helpers/getPrototypeOf");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "@babel/runtime/helpers/inherits");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! react-router */ "react-router");
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_router__WEBPACK_IMPORTED_MODULE_8__);









var errorBoundaryStyles = {
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "#E0E0E0",
  padding: 10,
  fontSize: 13,
  color: "#E57373",
  backgroundColor: "#F5F5F5",
  fontFamily: "monospace",
  margin: 10
};

var ErrorBoundary =
/*#__PURE__*/
function (_Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ErrorBoundary);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ErrorBoundary).call(this, props));
    _this.state = {
      hasError: false,
      error: null,
      info: null
    };
    var history = props.history; //listem history changes

    _this.unsubscribeFromHistory = history.listen(function () {
      if (_this.state.hasError) {
        _this.removeError();
      }
    });
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ErrorBoundary, [{
    key: "removeError",
    value: function removeError() {
      this.setState({
        hasError: false,
        error: null,
        info: null
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        hasError: true,
        error: error,
        info: info
      });

      if (this.props.onError) {
        this.props.onError(this.state);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.hasError) {
        var render = this.props.render; //call custom rendering if provided

        if (render) {
          return render(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, this.state, {
            retry: function retry(e) {
              e.preventDefault();

              _this2.removeError();
            }
          }));
        }

        var _this$state = this.state,
            error = _this$state.error,
            info = _this$state.info;

        var Log = function Log(_ref) {
          var log = _ref.log,
              label = _ref.label;
          return log && react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("div", null, react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("b", null, "[", label, "] : "), log);
        };

        var ErrorDetails = function ErrorDetails() {
          return react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_6___default.a.Fragment, null, react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement(Log, {
            log: error.message,
            label: "ERROR MESSAGE"
          }), react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement(Log, {
            log: error.stack,
            label: "ERROR STACK"
          }), react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement(Log, {
            log: info.componentStack,
            label: "COMPONENT STACK"
          }));
        }; //default rendering


        return react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("div", {
          style: errorBoundaryStyles
        }, react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("h5", null, "Unexpected error occured !"), react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement("a", {
          href: "#",
          style: {
            color: "#fff",
            backgroundColor: "#007bff",
            padding: 5,
            marginBottom: 10,
            display: "inline-block"
          },
          onClick: function onClick(e) {
            e.preventDefault();

            _this2.removeError();
          }
        }, "Retry loading"),  true && react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement(ErrorDetails, null));
      }

      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_6__["Component"]);

ErrorBoundary.propTypes = {
  render: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.func,
  children: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.node,
  onError: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.func,
  history: prop_types__WEBPACK_IMPORTED_MODULE_7___default.a.object
};
/* harmony default export */ __webpack_exports__["default"] = (Object(react_router__WEBPACK_IMPORTED_MODULE_8__["withRouter"])(ErrorBoundary));

/***/ }),

/***/ "./src/framework/routing/PrivateRoute.js":
/*!***********************************************!*\
  !*** ./src/framework/routing/PrivateRoute.js ***!
  \***********************************************/
/*! exports provided: PrivateRoute */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrivateRoute", function() { return PrivateRoute; });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "@babel/runtime/helpers/extends");
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "@babel/runtime/helpers/objectWithoutProperties");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react-router */ "react-router");
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../state */ "./src/framework/state/index.js");
/* harmony import */ var _backNavigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./backNavigation */ "./src/framework/routing/backNavigation.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils */ "./src/framework/utils/index.js");









var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      backTo = _ref.backTo,
      rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref, ["component", "backTo"]);

  return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react_router__WEBPACK_IMPORTED_MODULE_3__["Route"], _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, rest, {
    render: function render(props) {
      Object(_utils__WEBPACK_IMPORTED_MODULE_8__["validate"])([[!Component, "component prop is missing in PrivateRoute"]]);
      var permissions = _state__WEBPACK_IMPORTED_MODULE_6__["store"].getState().globals.permissions;
      var routeKey = props.match.path;
      if (backTo) _backNavigation__WEBPACK_IMPORTED_MODULE_7__["staticBackNavigations"][routeKey] = backTo;
      return routeKey in permissions ? react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(Component, _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0___default()({}, props, {
        permissions: permissions[routeKey]
      })) : react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react_router__WEBPACK_IMPORTED_MODULE_3__["Redirect"], {
        to: _config__WEBPACK_IMPORTED_MODULE_5__["config"].get("oauth.unAuthorizedRouteUrl")
      });
    }
  }));
};
PrivateRoute.propTypes = {
  component: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.func,
  match: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,
  backTo: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string
};

/***/ }),

/***/ "./src/framework/routing/backNavigation.js":
/*!*************************************************!*\
  !*** ./src/framework/routing/backNavigation.js ***!
  \*************************************************/
/*! exports provided: staticBackNavigations, setBackAction */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticBackNavigations", function() { return staticBackNavigations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBackAction", function() { return setBackAction; });
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../state */ "./src/framework/state/index.js");
/* harmony import */ var _router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./router */ "./src/framework/routing/router/index.js");
/* harmony import */ var _history__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./history */ "./src/framework/routing/history.js");
/* eslint-disable no-unused-vars */



/**
 * Predefined back navigations provided by PrivateRoute
 */

var staticBackNavigations = {};
var setBackAction = function setBackAction(event) {
  pushBackAction = event;
};
var pushBackAction = null;

function locationChangedEvent() {
  pushBackAction = null;
}

if (typeof window !== "undefined") {
  /**
   * Iterate up to find out the nearest "backTo" navigation url
   *
   * @param {string} currentPathName Current pathname
   */
  var getNearestBackUrl = function getNearestBackUrl(currentPathName) {
    var backUrl = null;
    var pathNames = currentPathName.split("/");
    if (pathNames[0] === "") pathNames.shift();

    while (pathNames.length) {
      var currentPath = "/".concat(pathNames.join("/"));

      if (staticBackNavigations[currentPath]) {
        backUrl = staticBackNavigations[currentPath];
        break;
      }

      pathNames.pop();
    }

    return backUrl;
  };
  /**
   * Hook pop state event to handle backnavigation
   */


  window.onpopstate = function () {//to disable forward btn when back navigated
    //TODO:Review what should be here

    /* window.history.pushState({}, "", "#");
    //dynamic back navigation
    //check pushBackAction assigned,call and return
    if (pushBackAction) {
      pushBackAction();
      return;
    }
    //static back navigation
    //get current route name
    const currentPathName = getState()[ROUTING_STORE_NAME].location.pathname;
    const staticBackUrl = getNearestBackUrl(currentPathName);
    //if provided bn,call replace
    if (staticBackUrl) {
      dispatch(replace(staticBackUrl));
    } */
  }; //reset pushBackAction event when location changed


  var history = Object(_history__WEBPACK_IMPORTED_MODULE_2__["getHistory"])();
  history.listen(locationChangedEvent);
}

/***/ }),

/***/ "./src/framework/routing/history.js":
/*!******************************************!*\
  !*** ./src/framework/routing/history.js ***!
  \******************************************/
/*! exports provided: getHistory, setHistory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHistory", function() { return getHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHistory", function() { return setHistory; });
/* harmony import */ var history__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! history */ "history");
/* harmony import */ var history__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(history__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ssr */ "./src/framework/ssr/index.js");



var _history;

var getHistory = function getHistory() {
  if (_history) {
    return _history;
  }

  return _history = Object(_ssr__WEBPACK_IMPORTED_MODULE_1__["isSSR"])() ? Object(history__WEBPACK_IMPORTED_MODULE_0__["createMemoryHistory"])() : Object(history__WEBPACK_IMPORTED_MODULE_0__["createBrowserHistory"])();
};
var setHistory = function setHistory(history) {
  _history = history;
};

/***/ }),

/***/ "./src/framework/routing/index.js":
/*!****************************************!*\
  !*** ./src/framework/routing/index.js ***!
  \****************************************/
/*! exports provided: getHistory, setHistory, PrivateRoute, setBackAction, ErrorBoundary, ConnectedRouter, getAction, getLocation, createMatchSelector, LOCATION_CHANGE, routerReducer, ROUTING_STORE_NAME, routerMiddleware, CALL_HISTORY_METHOD, push, replace, go, goBack, goForward, routerActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./router */ "./src/framework/routing/router/index.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["ConnectedRouter"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getAction", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["getAction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getLocation", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["getLocation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createMatchSelector", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["createMatchSelector"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["LOCATION_CHANGE"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["routerReducer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ROUTING_STORE_NAME", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["ROUTING_STORE_NAME"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["routerMiddleware"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["CALL_HISTORY_METHOD"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "push", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["push"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["replace"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "go", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["go"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["goBack"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["goForward"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return _router__WEBPACK_IMPORTED_MODULE_0__["routerActions"]; });

/* harmony import */ var _history__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./history */ "./src/framework/routing/history.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getHistory", function() { return _history__WEBPACK_IMPORTED_MODULE_1__["getHistory"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setHistory", function() { return _history__WEBPACK_IMPORTED_MODULE_1__["setHistory"]; });

/* harmony import */ var _PrivateRoute__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PrivateRoute */ "./src/framework/routing/PrivateRoute.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PrivateRoute", function() { return _PrivateRoute__WEBPACK_IMPORTED_MODULE_2__["PrivateRoute"]; });

/* harmony import */ var _backNavigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./backNavigation */ "./src/framework/routing/backNavigation.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setBackAction", function() { return _backNavigation__WEBPACK_IMPORTED_MODULE_3__["setBackAction"]; });

/* harmony import */ var _ErrorBoundary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ErrorBoundary */ "./src/framework/routing/ErrorBoundary.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return _ErrorBoundary__WEBPACK_IMPORTED_MODULE_4__["default"]; });







/***/ }),

/***/ "./src/framework/routing/router/ConnectedRouter.js":
/*!*********************************************************!*\
  !*** ./src/framework/routing/router/ConnectedRouter.js ***!
  \*********************************************************/
/*! exports provided: ConnectedRouter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return ConnectedRouter; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "@babel/runtime/helpers/possibleConstructorReturn");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "@babel/runtime/helpers/getPrototypeOf");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "@babel/runtime/helpers/inherits");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "@babel/runtime/helpers/assertThisInitialized");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! react-router */ "react-router");
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _history__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../history */ "./src/framework/routing/history.js");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./reducer */ "./src/framework/routing/router/reducer.js");
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../ssr */ "./src/framework/ssr/index.js");













var ConnectedRouter =
/*#__PURE__*/
function (_Component) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _getPrototypeOf2;

    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ConnectedRouter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, (_getPrototypeOf2 = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ConnectedRouter)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), "handleLocationChange", function (location, action) {
      _this.store.dispatch({
        type: _reducer__WEBPACK_IMPORTED_MODULE_11__["LOCATION_CHANGE"],
        payload: {
          location: location,
          action: action
        }
      });
    });

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ConnectedRouter, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          propsStore = _this$props.store,
          history = _this$props.history;
      this.store = propsStore || this.context.store;
      if (history) Object(_history__WEBPACK_IMPORTED_MODULE_10__["setHistory"])(history);
      this.history = Object(_history__WEBPACK_IMPORTED_MODULE_10__["getHistory"])();
      this.isSSR = Object(_ssr__WEBPACK_IMPORTED_MODULE_12__["isSSR"])();

      if (!this.isSSR) {
        this.unsubscribeFromHistory = this.history.listen(this.handleLocationChange);
        this.handleLocationChange(this.history.location);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          context = _this$props2.context,
          location = _this$props2.location,
          children = _this$props2.children;
      return this.isSSR ? react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(react_router__WEBPACK_IMPORTED_MODULE_9__["StaticRouter"], {
        context: context,
        location: location
      }, children) : react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(react_router__WEBPACK_IMPORTED_MODULE_9__["Router"], {
        history: this.history
      }, children);
    }
  }]);

  return ConnectedRouter;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(ConnectedRouter, "propTypes", {
  store: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
  history: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
  children: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.node,
  context: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
  location: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.string
});

_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(ConnectedRouter, "contextTypes", {
  store: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object,
  history: prop_types__WEBPACK_IMPORTED_MODULE_8___default.a.object
});

/***/ }),

/***/ "./src/framework/routing/router/actions.js":
/*!*************************************************!*\
  !*** ./src/framework/routing/router/actions.js ***!
  \*************************************************/
/*! exports provided: CALL_HISTORY_METHOD, push, replace, go, goBack, goForward, routerActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "push", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "go", function() { return go; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return goBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return goForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return routerActions; });
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = "@@router/CALL_HISTORY_METHOD";

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: {
        method: method,
        args: args
      }
    };
  };
}
/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */


var push = updateLocation("push");
var replace = updateLocation("replace");
var go = updateLocation("go");
var goBack = updateLocation("goBack");
var goForward = updateLocation("goForward");
var routerActions = {
  push: push,
  replace: replace,
  go: go,
  goBack: goBack,
  goForward: goForward
};

/***/ }),

/***/ "./src/framework/routing/router/index.js":
/*!***********************************************!*\
  !*** ./src/framework/routing/router/index.js ***!
  \***********************************************/
/*! exports provided: ConnectedRouter, getAction, getLocation, createMatchSelector, LOCATION_CHANGE, routerReducer, ROUTING_STORE_NAME, routerMiddleware, CALL_HISTORY_METHOD, push, replace, go, goBack, goForward, routerActions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ConnectedRouter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ConnectedRouter */ "./src/framework/routing/router/ConnectedRouter.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return _ConnectedRouter__WEBPACK_IMPORTED_MODULE_0__["ConnectedRouter"]; });

/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./selectors */ "./src/framework/routing/router/selectors.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getAction", function() { return _selectors__WEBPACK_IMPORTED_MODULE_1__["getAction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getLocation", function() { return _selectors__WEBPACK_IMPORTED_MODULE_1__["getLocation"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createMatchSelector", function() { return _selectors__WEBPACK_IMPORTED_MODULE_1__["createMatchSelector"]; });

/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reducer */ "./src/framework/routing/router/reducer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return _reducer__WEBPACK_IMPORTED_MODULE_2__["LOCATION_CHANGE"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return _reducer__WEBPACK_IMPORTED_MODULE_2__["routerReducer"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ROUTING_STORE_NAME", function() { return _reducer__WEBPACK_IMPORTED_MODULE_2__["ROUTING_STORE_NAME"]; });

/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./actions */ "./src/framework/routing/router/actions.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["CALL_HISTORY_METHOD"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "push", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["push"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["replace"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "go", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["go"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["goBack"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["goForward"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return _actions__WEBPACK_IMPORTED_MODULE_3__["routerActions"]; });

/* harmony import */ var _middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./middleware */ "./src/framework/routing/router/middleware.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return _middleware__WEBPACK_IMPORTED_MODULE_4__["routerMiddleware"]; });







/***/ }),

/***/ "./src/framework/routing/router/middleware.js":
/*!****************************************************!*\
  !*** ./src/framework/routing/router/middleware.js ***!
  \****************************************************/
/*! exports provided: routerMiddleware */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return routerMiddleware; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./actions */ "./src/framework/routing/router/actions.js");


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */

function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions__WEBPACK_IMPORTED_MODULE_1__["CALL_HISTORY_METHOD"]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;
        history[method].apply(history, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(args));
      };
    };
  };
}

/***/ }),

/***/ "./src/framework/routing/router/reducer.js":
/*!*************************************************!*\
  !*** ./src/framework/routing/router/reducer.js ***!
  \*************************************************/
/*! exports provided: ROUTING_STORE_NAME, LOCATION_CHANGE, routerReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTING_STORE_NAME", function() { return ROUTING_STORE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return LOCATION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return routerReducer; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);


/**
 * Name with which routing represented in store
 */
var ROUTING_STORE_NAME = "routing";
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */

var LOCATION_CHANGE = "@@router/LOCATION_CHANGE";
var initialState = {
  location: null,
  action: null
};
/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */

function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    var _ref2 = payload || {},
        location = _ref2.location,
        action = _ref2.action;

    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, state, {
      location: location,
      action: action
    });
  }

  return state;
}

/***/ }),

/***/ "./src/framework/routing/router/selectors.js":
/*!***************************************************!*\
  !*** ./src/framework/routing/router/selectors.js ***!
  \***************************************************/
/*! exports provided: getLocation, getAction, createMatchSelector */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocation", function() { return getLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAction", function() { return getAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMatchSelector", function() { return createMatchSelector; });
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react-router */ "react-router");
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reducer */ "./src/framework/routing/router/reducer.js");


var getLocation = function getLocation(state) {
  return state[_reducer__WEBPACK_IMPORTED_MODULE_1__["ROUTING_STORE_NAME"]].location;
};
var getAction = function getAction(state) {
  return state[_reducer__WEBPACK_IMPORTED_MODULE_1__["ROUTING_STORE_NAME"]].action;
};
var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }

    lastPathname = pathname;
    var match = Object(react_router__WEBPACK_IMPORTED_MODULE_0__["matchPath"])(pathname, path);

    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }

    return lastMatch;
  };
};

/***/ }),

/***/ "./src/framework/signalr/hub.js":
/*!**************************************!*\
  !*** ./src/framework/signalr/hub.js ***!
  \**************************************/
/*! exports provided: Hub */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return Hub; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _aspnet_signalr_dist_browser_signalr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @aspnet/signalr/dist/browser/signalr */ "@aspnet/signalr/dist/browser/signalr");
/* harmony import */ var _aspnet_signalr_dist_browser_signalr__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_aspnet_signalr_dist_browser_signalr__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Hub class
 * @description Create a new websocket connection
 */

var Hub =
/*#__PURE__*/
function () {
  function Hub(options) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Hub);

    this.options = options; //create connection

    this.connection = new _aspnet_signalr_dist_browser_signalr__WEBPACK_IMPORTED_MODULE_2__["HubConnectionBuilder"]().withUrl(options.url).configureLogging(options.logging && _aspnet_signalr_dist_browser_signalr__WEBPACK_IMPORTED_MODULE_2__["LogLevel"].Trace).build();
    this.methods = {};
    this.registerMethods();

    if (options.autoConnect) {
      this.connect();
    }
  }
  /**
   * Register listeners and methods
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Hub, [{
    key: "registerMethods",
    value: function registerMethods() {
      var _this = this;

      var _this$options = this.options,
          methods = _this$options.methods,
          listeners = _this$options.listeners; //register server methods for listening

      if (listeners) {
        Object.keys(listeners).forEach(function (methodName) {
          return _this.connection.on(methodName, function () {
            var _listeners$methodName;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            (_listeners$methodName = listeners[methodName]).call.apply(_listeners$methodName, [_this.options.context || _this].concat(args));
          });
        });
      } //register server methods for triggering


      if (methods) {
        methods.forEach(function (method) {
          _this.methods[method] = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            args.unshift(method);

            _this.connection.invoke.apply(_this.connection, args);
          };
        });
      }
    }
    /**
     * Trigger state changed event
     *
     * @param {*} args State params
     */

  }, {
    key: "stateChanged",
    value: function stateChanged() {
      var _this$options$stateCh;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.options.stateChanged && (_this$options$stateCh = this.options.stateChanged).call.apply(_this$options$stateCh, [this.options.context || this].concat(args));
    }
    /**
     * Connect to signalr server
     */

  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      this.connection.start().then(function () {
        _this2.stateChanged("connected");
      }, function (err) {
        _this2.options.errorHandler && _this2.options.errorHandler(err);

        _this2.stateChanged("notconnected", err);
      });
    }
    /**
     * Disconnect from server
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this3 = this;

      this.connection.stop().then(function () {
        _this3.stateChanged("disconnected");
      }, function (err) {
        _this3.stateChanged("disconnectfailed", err);
      });
    }
  }]);

  return Hub;
}();

/***/ }),

/***/ "./src/framework/signalr/index.js":
/*!****************************************!*\
  !*** ./src/framework/signalr/index.js ***!
  \****************************************/
/*! exports provided: Hub */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./hub */ "./src/framework/signalr/hub.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return _hub__WEBPACK_IMPORTED_MODULE_0__["Hub"]; });



/***/ }),

/***/ "./src/framework/ssr/index.js":
/*!************************************!*\
  !*** ./src/framework/ssr/index.js ***!
  \************************************/
/*! exports provided: domainTasks, isSSR, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "domainTasks", function() { return domainTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSSR", function() { return isSSR; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom/server */ "react-dom/server");
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom_server__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_loadable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-loadable */ "react-loadable");
/* harmony import */ var react_loadable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_loadable__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");




var domainTasks = {};
var isSSR = function isSSR() {
  return _config__WEBPACK_IMPORTED_MODULE_3__["config"].get("isSSR");
};
/* harmony default export */ __webpack_exports__["default"] = (function (Component) {
  //first render to tirgger async calls
  react_dom_server__WEBPACK_IMPORTED_MODULE_1___default.a.renderToString(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, null)); //wait for domain tasks

  var tasksP = Object.keys(domainTasks).reduce(function (memo, key) {
    memo.push(domainTasks[key].promise);
    return memo;
  }, []);
  return Promise.all(tasksP).then(function () {
    var initialModules = [];
    domainTasks = {}; //second render to wait for async calls

    var initialMarkup = react_dom_server__WEBPACK_IMPORTED_MODULE_1___default.a.renderToString(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_loadable__WEBPACK_IMPORTED_MODULE_2___default.a.Capture, {
      report: function report(moduleName) {
        return initialModules.push(moduleName);
      }
    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, null)));
    return {
      initialMarkup: initialMarkup,
      initialModules: initialModules
    };
  });
});

/***/ }),

/***/ "./src/framework/state/errorHandler.js":
/*!*********************************************!*\
  !*** ./src/framework/state/errorHandler.js ***!
  \*********************************************/
/*! exports provided: errorHandler, removeErrorIfAny */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorHandler", function() { return errorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeErrorIfAny", function() { return removeErrorIfAny; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! . */ "./src/framework/state/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");
/* harmony import */ var _factories_requestHelperFactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./factories/requestHelperFactory */ "./src/framework/state/factories/requestHelperFactory.js");



function errorHandler(_ref) {
  var name = _ref.name,
      action = _ref.action,
      error = _ref.error;
  var response = error.response; //dispatch error model

  ___WEBPACK_IMPORTED_MODULE_0__["dispatch"][_config__WEBPACK_IMPORTED_MODULE_1__["constants"].models.ERROR_MODEL_NAME].add({
    name: name,
    action: action,
    error: Object(_factories_requestHelperFactory__WEBPACK_IMPORTED_MODULE_2__["extractData"])(response.data) || response.statusText || response
  }); //rethrow error

  throw error;
}
function removeErrorIfAny(_ref2) {
  var name = _ref2.name,
      action = _ref2.action;
  var errors = Object(___WEBPACK_IMPORTED_MODULE_0__["getState"])()[_config__WEBPACK_IMPORTED_MODULE_1__["constants"].models.ERROR_MODEL_NAME];

  if (errors.models[name] || errors.effects[name] && errors.effects[name][action]) {
    ___WEBPACK_IMPORTED_MODULE_0__["dispatch"][_config__WEBPACK_IMPORTED_MODULE_1__["constants"].models.ERROR_MODEL_NAME].remove({
      name: name,
      action: action
    });
  }
}

/***/ }),

/***/ "./src/framework/state/factories/exposeFactory.js":
/*!********************************************************!*\
  !*** ./src/framework/state/factories/exposeFactory.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @rematch/core */ "@rematch/core");
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_rematch_core__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Encapsulate action creators to make them available as export module
 *
 * @param {*} actions Methods to be exposed (Reducers and Effects)
 * @param {string} name Model register name
 */

var exposeActionCreators = function exposeActionCreators(actions, name) {
  return Object.keys(actions).reduce(function (result, key) {
    result[key] = function () {
      var _dispatch$name;

      //Return value of actions removed for the name of redux pattern
      //return dispatch[name][key](...args);
      (_dispatch$name = _rematch_core__WEBPACK_IMPORTED_MODULE_2__["dispatch"][name])[key].apply(_dispatch$name, arguments);
    };

    return result;
  }, {});
};

var exposeHubMethods = function exposeHubMethods() {
  var hubs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments.length > 1 ? arguments[1] : undefined;
  return Object.keys(hubs).reduce(function (result, hubName) {
    result[hubName] = {};
    ["connect", "disconnect"].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(hubs[hubName].methods || [])).forEach(function (action) {
      result[hubName][action] = function () {
        var _dispatch$name$hubs$h;

        return (_dispatch$name$hubs$h = _rematch_core__WEBPACK_IMPORTED_MODULE_2__["dispatch"][name].hubs[hubName])[action].apply(_dispatch$name$hubs$h, arguments);
      };
    });
    return result;
  }, {});
};
/**
 * Expose state of model
 *
 * @param {*} name Store name
 */


var getState = function getState(name) {
  return function () {
    return Object(_rematch_core__WEBPACK_IMPORTED_MODULE_2__["getState"])()[name];
  };
};
/**
 * State factory function
 *
 * @param {*} config State config
 * @returns {function} Returns state factory mixin function
 */


/* harmony default export */ __webpack_exports__["default"] = (function () {
  return function (_ref) {
    var methods = _ref.methods,
        reducers = _ref.reducers,
        hubs = _ref.hubs,
        effects = _ref.effects,
        name = _ref.config.name;

    //check keys is unique of all methods,effects and reducers
    if (true) {
      var keys = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(methods ? Object.keys(methods) : []).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(reducers ? Object.keys(reducers) : []), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(effects ? Object.keys(effects) : []));

      var intersectedKeys = keys.sort().reduce(function (r, a, i, aa) {
        if (i && aa[i - 1] === a) {
          r.push(a);
        }

        return r;
      }, []);

      if (intersectedKeys.length) {
        throw new Error("there is duplicated key(s) of ".concat(name, " model between either methods,effects or reducers.Keys = ").concat(intersectedKeys.join(",")));
      }
    }

    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, methods, exposeActionCreators(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, reducers, effects), name), {
      hubs: exposeHubMethods(hubs, name),
      getState: getState(name)
    });
  };
});

/***/ }),

/***/ "./src/framework/state/factories/index.js":
/*!************************************************!*\
  !*** ./src/framework/state/factories/index.js ***!
  \************************************************/
/*! exports provided: withRequestHelper, withExpose, withState, withMethods, withValidate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _requestHelperFactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./requestHelperFactory */ "./src/framework/state/factories/requestHelperFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withRequestHelper", function() { return _requestHelperFactory__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _exposeFactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exposeFactory */ "./src/framework/state/factories/exposeFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withExpose", function() { return _exposeFactory__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _stateFactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./stateFactory */ "./src/framework/state/factories/stateFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return _stateFactory__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _methodWrapperFactory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./methodWrapperFactory */ "./src/framework/state/factories/methodWrapperFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withMethods", function() { return _methodWrapperFactory__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _validateFactory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./validateFactory */ "./src/framework/state/factories/validateFactory.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "withValidate", function() { return _validateFactory__WEBPACK_IMPORTED_MODULE_4__["default"]; });








/***/ }),

/***/ "./src/framework/state/factories/methodWrapperFactory.js":
/*!***************************************************************!*\
  !*** ./src/framework/state/factories/methodWrapperFactory.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "@babel/runtime/regenerator");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "@babel/runtime/helpers/asyncToGenerator");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "@babel/runtime/helpers/objectWithoutProperties");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _requestHelperFactory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./requestHelperFactory */ "./src/framework/state/factories/requestHelperFactory.js");
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../ssr */ "./src/framework/ssr/index.js");
/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../async */ "./src/framework/async/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! .. */ "./src/framework/state/index.js");









/* harmony default export */ __webpack_exports__["default"] = (function () {
  return function (_ref) {
    var _ref$methods = _ref.methods,
        methods = _ref$methods === void 0 ? {} : _ref$methods,
        config = _ref.config,
        rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3___default()(_ref, ["methods", "config"]);

    var wrappedMethods = Object.keys(methods).reduce(function (result, key) {
      result[key] =
      /*#__PURE__*/
      _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()(
      /*#__PURE__*/
      _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
        var actionName,
            methodResult,
            apiName,
            serviceName,
            _methods$key,
            _len,
            args,
            _key,
            response,
            err,
            _args = arguments;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                actionName = "methods/".concat(key);

                if (!Object(_ssr__WEBPACK_IMPORTED_MODULE_5__["isSSR"])()) {
                  _context.next = 5;
                  break;
                }

                if (!Object(___WEBPACK_IMPORTED_MODULE_7__["getState"])().domainTasks.includes(actionName)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Promise.resolve());

              case 4:
                _ssr__WEBPACK_IMPORTED_MODULE_5__["domainTasks"][actionName] = new _async__WEBPACK_IMPORTED_MODULE_6__["Deferred"]();

              case 5:
                apiName = config.apiName, serviceName = config.serviceName;
                _context.prev = 6;

                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _context.next = 10;
                return (_methods$key = methods[key]).call.apply(_methods$key, [Object.assign(Object(_requestHelperFactory__WEBPACK_IMPORTED_MODULE_4__["default"])(serviceName, apiName), this)].concat(args));

              case 10:
                methodResult = _context.sent;
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                response = _context.t0.response;
                err = Object(_requestHelperFactory__WEBPACK_IMPORTED_MODULE_4__["extractData"])(response.data) || response.statusText || response;
                throw err;

              case 18:
                if (Object(_ssr__WEBPACK_IMPORTED_MODULE_5__["isSSR"])()) {
                  _ssr__WEBPACK_IMPORTED_MODULE_5__["domainTasks"][actionName].resolve();
                  ___WEBPACK_IMPORTED_MODULE_7__["dispatch"].domainTasks.add(actionName);
                }

                return _context.abrupt("return", methodResult);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));
      return result;
    }, {});
    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
      methods: wrappedMethods,
      config: config
    }, rest);
  };
});

/***/ }),

/***/ "./src/framework/state/factories/requestHelperFactory.js":
/*!***************************************************************!*\
  !*** ./src/framework/state/factories/requestHelperFactory.js ***!
  \***************************************************************/
/*! exports provided: extractData, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extractData", function() { return extractData; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "@babel/runtime/helpers/objectWithoutProperties");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "@babel/runtime/helpers/typeof");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../async */ "./src/framework/async/index.js");
/* harmony import */ var _makeFqdn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../makeFqdn */ "./src/framework/state/makeFqdn.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");






/**
 * Extract data prop of response
 *
 * @param {Promise.<*>} response Fetch response
 */

function extractData(response) {
  if (!response || Blob && response instanceof Blob) return response;
  var dataJsonNodeName = _config__WEBPACK_IMPORTED_MODULE_5__["config"].get("response.responseJsonDataName");
  return dataJsonNodeName ? response[dataJsonNodeName] : response;
}

function normalize() {
  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(arguments[0]) === "object") {
    return arguments[0];
  } else {
    var _arguments = Array.prototype.slice.call(arguments),
        action = _arguments[0],
        payload = _arguments[1],
        options = _arguments[2];

    return {
      action: action,
      payload: payload,
      options: options
    };
  }
}

/* harmony default export */ __webpack_exports__["default"] = (function (service, api) {
  return {
    /**
     * Make GET request with given parameters
     *
     * @param {string} action Action name of controller
     * @param {*} params Filter
     * @param {string} controller Controller name
     * @returns {Promise.<*>} Returns promise result
     */
    getAsync: function getAsync() {
      var _normalize = normalize.apply(void 0, arguments),
          action = _normalize.action,
          apiName = _normalize.apiName,
          params = _normalize.payload,
          serviceName = _normalize.serviceName,
          rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_normalize, ["action", "apiName", "payload", "serviceName"]);

      var url = Object(_makeFqdn__WEBPACK_IMPORTED_MODULE_4__["default"])(action, apiName || api, serviceName || service);
      return Object(_async__WEBPACK_IMPORTED_MODULE_3__["getAsync"])(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
        url: url,
        params: params
      }, rest)).then(extractData);
    },

    /**
     * Make POST request with given parameters
     *
     * @param {string} action Action name of controller
     * @param {*} data Filter
     * @param {string} controller Controller name
     * @returns {Promise.<*>} Returns promise result
     */
    postAsync: function postAsync() {
      var _normalize2 = normalize.apply(void 0, arguments),
          action = _normalize2.action,
          apiName = _normalize2.apiName,
          serviceName = _normalize2.serviceName,
          data = _normalize2.payload,
          rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_normalize2, ["action", "apiName", "serviceName", "payload"]);

      var url = Object(_makeFqdn__WEBPACK_IMPORTED_MODULE_4__["default"])(action, apiName || api, serviceName || service);
      return Object(_async__WEBPACK_IMPORTED_MODULE_3__["postAsync"])(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
        url: url,
        data: data
      }, rest)).then(extractData);
    },

    /**
     * Create fqdn according to given settings of model
     *
     * @param {string} action Action name
     */
    getFqdn: function getFqdn(action) {
      return Object(_makeFqdn__WEBPACK_IMPORTED_MODULE_4__["default"])(action, api, service);
    }
  };
});

/***/ }),

/***/ "./src/framework/state/factories/stateFactory.js":
/*!*******************************************************!*\
  !*** ./src/framework/state/factories/stateFactory.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "@babel/runtime/helpers/objectWithoutProperties");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _registerModel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../registerModel */ "./src/framework/state/registerModel.js");



/**
 * Generic reducer for user effects if not defined particular effect
 *
 * @param {Object} state Model state
 * @param {*} payload Payload of action
 */

var genericReducer = function genericReducer(state, payload) {
  return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({}, state, payload);
};
/**
 * State factory function
 *
 * @param {*} config State config
 * @returns {function} Returns state factory mixin function
 */


/* harmony default export */ __webpack_exports__["default"] = (function () {
  return function (_ref) {
    var reducers = _ref.reducers,
        effects = _ref.effects,
        hubs = _ref.hubs,
        config = _ref.config,
        rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0___default()(_ref, ["reducers", "effects", "hubs", "config"]);

    /**
     * Base model definitiion
     */
    if (config.name) {
      var rematchModel = {
        state: config.initialState || {},
        name: config.name,
        reducers: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
          genericReducer: genericReducer
        }, reducers),
        effects: effects,
        hubs: hubs,
        config: config
      }; //register model

      Object(_registerModel__WEBPACK_IMPORTED_MODULE_2__["registerModel"])(rematchModel);
    }

    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_1___default()({
      config: config,
      reducers: reducers,
      effects: effects,
      hubs: hubs
    }, rest);
  };
});

/***/ }),

/***/ "./src/framework/state/factories/validateFactory.js":
/*!**********************************************************!*\
  !*** ./src/framework/state/factories/validateFactory.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "@babel/runtime/helpers/objectWithoutProperties");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils */ "./src/framework/utils/index.js");



/**
 * Model validation factory
 */

/* harmony default export */ __webpack_exports__["default"] = (function () {
  return function (_ref) {
    var config = _ref.config,
        methods = _ref.methods,
        effects = _ref.effects,
        reducers = _ref.reducers,
        rest = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref, ["config", "methods", "effects", "reducers"]);

    var name = config.name,
        apiName = config.apiName; //validate name

    Object(_utils__WEBPACK_IMPORTED_MODULE_2__["validate"])([[!name && (effects || reducers), "store name is missing"], [!apiName && (effects || methods), "apiName is missing when effects or methods is provided"]]);
    return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
      config: config,
      methods: methods,
      effects: effects,
      reducers: reducers
    }, rest);
  };
});

/***/ }),

/***/ "./src/framework/state/index.js":
/*!**************************************!*\
  !*** ./src/framework/state/index.js ***!
  \**************************************/
/*! exports provided: dispatch, getState, store, addGlobalModel, default, model */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./model */ "./src/framework/state/model.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "model", function() { return _model__WEBPACK_IMPORTED_MODULE_0__["model"]; });

/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @rematch/core */ "@rematch/core");
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_rematch_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dispatch", function() { return _rematch_core__WEBPACK_IMPORTED_MODULE_1__["dispatch"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getState", function() { return _rematch_core__WEBPACK_IMPORTED_MODULE_1__["getState"]; });

/* harmony import */ var _init__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./init */ "./src/framework/state/init.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "store", function() { return _init__WEBPACK_IMPORTED_MODULE_2__["store"]; });

/* harmony import */ var _registerModel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./registerModel */ "./src/framework/state/registerModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addGlobalModel", function() { return _registerModel__WEBPACK_IMPORTED_MODULE_3__["addGlobalModel"]; });






/* harmony default export */ __webpack_exports__["default"] = (_init__WEBPACK_IMPORTED_MODULE_2__["init"]);

/***/ }),

/***/ "./src/framework/state/init.js":
/*!*************************************!*\
  !*** ./src/framework/state/init.js ***!
  \*************************************/
/*! exports provided: store, init */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @rematch/core */ "@rematch/core");
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_rematch_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rematch_loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @rematch/loading */ "@rematch/loading");
/* harmony import */ var _rematch_loading__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_rematch_loading__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _plugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./plugins */ "./src/framework/state/plugins/index.js");
/* harmony import */ var _plugins_persistPlugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./plugins/persistPlugin */ "./src/framework/state/plugins/persistPlugin.js");
/* harmony import */ var _plugins_responsivePlugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./plugins/responsivePlugin */ "./src/framework/state/plugins/responsivePlugin.js");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./models */ "./src/framework/state/models/index.js");
/* harmony import */ var _registerModel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./registerModel */ "./src/framework/state/registerModel.js");









var store;
var init = function init(_ref) {
  var _ref$models = _ref.models,
      models = _ref$models === void 0 ? {} : _ref$models,
      _ref$plugins = _ref.plugins,
      extraPlugins = _ref$plugins === void 0 ? [] : _ref$plugins,
      _ref$redux = _ref.redux,
      redux = _ref$redux === void 0 ? {} : _ref$redux,
      _ref$loadingConfig = _ref.loadingConfig,
      loadingConfig = _ref$loadingConfig === void 0 ? {} : _ref$loadingConfig,
      _ref$persistConfig = _ref.persistConfig,
      persistConfig = _ref$persistConfig === void 0 ? {} : _ref$persistConfig,
      responsiveConfig = _ref.responsiveConfig;
  store = Object(_rematch_core__WEBPACK_IMPORTED_MODULE_2__["init"])({
    plugins: [Object(_plugins_responsivePlugin__WEBPACK_IMPORTED_MODULE_6__["default"])(responsiveConfig), Object(_plugins_persistPlugin__WEBPACK_IMPORTED_MODULE_5__["default"])(persistConfig)].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(_plugins__WEBPACK_IMPORTED_MODULE_4__["plugins"]), [_rematch_loading__WEBPACK_IMPORTED_MODULE_3___default()(loadingConfig)], _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(extraPlugins)),
    models: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, Object(_registerModel__WEBPACK_IMPORTED_MODULE_8__["getGlobalModels"])(), models, _models__WEBPACK_IMPORTED_MODULE_7__),
    redux: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
      enhancers: []
    }, redux)
  });
  return store;
};

/***/ }),

/***/ "./src/framework/state/isBuiltInModel.js":
/*!***********************************************!*\
  !*** ./src/framework/state/isBuiltInModel.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");

/* harmony default export */ __webpack_exports__["default"] = (function (modelName) {
  return [_config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.ERROR_MODEL_NAME, _config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.DOMAIN_TASK_MODEL_NAME, _config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.GLOBALS_MODEL_NAME, _config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.LANG_MODEL_NAME, _config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.LOADING_MODEL_NAME].includes(modelName);
});

/***/ }),

/***/ "./src/framework/state/makeFqdn.js":
/*!*****************************************!*\
  !*** ./src/framework/state/makeFqdn.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../config */ "./src/framework/config/index.js");

/**
 * Generate absolute uri
 *
 * @param {string} action Action name of controller
 * @returns {string} Returns full absolute uri
 */

/* harmony default export */ __webpack_exports__["default"] = (function (action, apiName, serviceName) {
  var currentDomain = "".concat(location.protocol, "//").concat(location.host);
  var services = _config__WEBPACK_IMPORTED_MODULE_0__["config"].get("services") || {};
  var urlParts = [services[serviceName] || _config__WEBPACK_IMPORTED_MODULE_0__["config"].get("baseServiceUrl") || currentDomain, !services[serviceName] && serviceName, _config__WEBPACK_IMPORTED_MODULE_0__["config"].get("request.defaultApiPrefix"), apiName, action];
  return urlParts.filter(Boolean).join("/");
});

/***/ }),

/***/ "./src/framework/state/model.js":
/*!**************************************!*\
  !*** ./src/framework/state/model.js ***!
  \**************************************/
/*! exports provided: model */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "model", function() { return model; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./src/framework/utils/index.js");
/* harmony import */ var _factories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./factories */ "./src/framework/state/factories/index.js");


/**
 * Crud Model
 *
 * @param {*} crudModelConfig Crud model configuration
 */

var model = function model(api) {
  return Object(_utils__WEBPACK_IMPORTED_MODULE_0__["pipe"])(Object(_factories__WEBPACK_IMPORTED_MODULE_1__["withValidate"])(), Object(_factories__WEBPACK_IMPORTED_MODULE_1__["withState"])(), Object(_factories__WEBPACK_IMPORTED_MODULE_1__["withMethods"])(), Object(_factories__WEBPACK_IMPORTED_MODULE_1__["withExpose"])())(api);
};

/***/ }),

/***/ "./src/framework/state/models/index.js":
/*!*********************************************!*\
  !*** ./src/framework/state/models/index.js ***!
  \*********************************************/
/*! exports provided: langModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _langModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./langModel */ "./src/framework/state/models/langModel.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "langModel", function() { return _langModel__WEBPACK_IMPORTED_MODULE_0__["langModel"]; });



/***/ }),

/***/ "./src/framework/state/models/langModel.js":
/*!*************************************************!*\
  !*** ./src/framework/state/models/langModel.js ***!
  \*************************************************/
/*! exports provided: langModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "langModel", function() { return langModel; });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");

var langModel = {
  name: _config__WEBPACK_IMPORTED_MODULE_0__["constants"].models.LANG_MODEL_NAME,
  state: {
    culture: _config__WEBPACK_IMPORTED_MODULE_0__["constants"].i18n.DEFAULT_LANG,
    locales: {}
  },
  reducers: {
    setLang: function setLang(state, culture) {
      return {
        culture: culture
      };
    }
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/domainTasksPlugin.js":
/*!**********************************************************!*\
  !*** ./src/framework/state/plugins/domainTasksPlugin.js ***!
  \**********************************************************/
/*! exports provided: domainTasksPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "domainTasksPlugin", function() { return domainTasksPlugin; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "@babel/runtime/regenerator");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "@babel/runtime/helpers/asyncToGenerator");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../ssr */ "./src/framework/ssr/index.js");
/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../async */ "./src/framework/async/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! .. */ "./src/framework/state/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");
/* harmony import */ var _isBuiltInModel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../isBuiltInModel */ "./src/framework/state/isBuiltInModel.js");








var domainTasksList = {
  name: _config__WEBPACK_IMPORTED_MODULE_6__["constants"].models.DOMAIN_TASK_MODEL_NAME,
  reducers: {
    add: function add(state, action) {
      return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(state).concat([action]);
    },
    remove: function remove(state, action) {
      return state.filter(function (item) {
        return item !== action;
      });
    }
  },
  state: []
};
var domainTasksPlugin = {
  config: {
    models: {
      domainTasksList: domainTasksList
    }
  },
  init: function init(_ref) {
    var effects = _ref.effects,
        dispatch = _ref.dispatch;
    return {
      onModel: function onModel(model) {
        if (!Object(_ssr__WEBPACK_IMPORTED_MODULE_3__["isSSR"])() || Object(_isBuiltInModel__WEBPACK_IMPORTED_MODULE_7__["default"])(model.name)) return;
        Object.keys(model.effects || {}).forEach(function (effectName) {
          var actionName = "".concat(model.name, "/").concat(effectName);
          var orjEffect = effects[actionName];
          effects[actionName] =
          /*#__PURE__*/
          _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(
          /*#__PURE__*/
          _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
            var _args = arguments;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!Object(___WEBPACK_IMPORTED_MODULE_5__["getState"])().domainTasks.includes(actionName)) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return", Promise.resolve());

                  case 2:
                    _context.prev = 2;
                    _context.next = 5;
                    return orjEffect.apply(void 0, _args);

                  case 5:
                    _ssr__WEBPACK_IMPORTED_MODULE_3__["domainTasks"][actionName].resolve();
                    dispatch.domainTasks.add(actionName);
                    _context.next = 13;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](2);
                    _ssr__WEBPACK_IMPORTED_MODULE_3__["domainTasks"][actionName].reject(_context.t0);
                    throw _context.t0;

                  case 13:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[2, 9]]);
          }));
        });
      },
      middleware: function middleware(store) {
        return function (next) {
          return function (action) {
            if (Object(_ssr__WEBPACK_IMPORTED_MODULE_3__["isSSR"])() && action.type in effects) {
              if (!store.getState().domainTasks.includes(action.type)) _ssr__WEBPACK_IMPORTED_MODULE_3__["domainTasks"][action.type] = new _async__WEBPACK_IMPORTED_MODULE_4__["Deferred"]();
            } else {
              return next(action);
            }
          };
        };
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/effectHelperPlugin.js":
/*!***********************************************************!*\
  !*** ./src/framework/state/plugins/effectHelperPlugin.js ***!
  \***********************************************************/
/*! exports provided: effectHelperPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effectHelperPlugin", function() { return effectHelperPlugin; });
/* harmony import */ var _factories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../factories */ "./src/framework/state/factories/index.js");

/**
 * Effect async helpers plugin
 */

var effectHelperPlugin = {
  init: function init(_ref) {
    var dispatch = _ref.dispatch;
    return {
      onModel: function onModel(model) {
        if (!model.config) return;
        var _model$config = model.config,
            apiName = _model$config.apiName,
            serviceName = _model$config.serviceName;
        Object.assign(dispatch[model.name], Object(_factories__WEBPACK_IMPORTED_MODULE_0__["withRequestHelper"])(serviceName, apiName));
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/effectWrapperPlugin.js":
/*!************************************************************!*\
  !*** ./src/framework/state/plugins/effectWrapperPlugin.js ***!
  \************************************************************/
/*! exports provided: effectWrapperPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effectWrapperPlugin", function() { return effectWrapperPlugin; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/regenerator */ "@babel/runtime/regenerator");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "@babel/runtime/helpers/asyncToGenerator");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils */ "./src/framework/utils/index.js");
/* harmony import */ var _errorHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../errorHandler */ "./src/framework/state/errorHandler.js");




var store;
/**
 * Wrap user defined effects with default reducer
 */

var effectWrapperPlugin = {
  init: function init(_ref) {
    var effects = _ref.effects,
        dispatch = _ref.dispatch;
    return {
      onStoreCreated: function onStoreCreated(_store) {
        store = _store;
      },
      onModel: function onModel(model) {
        Object.keys(model.effects || {}).forEach(function (effectName) {
          var actionName = "".concat(model.name, "/").concat(effectName);
          var orjEffect = effects[actionName];
          effects[actionName] =
          /*#__PURE__*/
          _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()(
          /*#__PURE__*/
          _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
            var domainTasks,
                effectResult,
                _args = arguments;
            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    //skip if request already fetched from server (ssr)
                    //remove for the first request,subsequent reqs will make a request
                    domainTasks = store.getState().domainTasks;

                    if (!domainTasks.includes(actionName)) {
                      _context.next = 4;
                      break;
                    }

                    dispatch.domainTasks.remove(actionName);
                    return _context.abrupt("return", Promise.resolve());

                  case 4:
                    //remove error on effect before starting effect
                    Object(_errorHandler__WEBPACK_IMPORTED_MODULE_3__["removeErrorIfAny"])({
                      name: model.name,
                      action: effectName
                    }); //call effect

                    _context.prev = 5;
                    _context.next = 8;
                    return orjEffect.apply(void 0, _args);

                  case 8:
                    effectResult = _context.sent;

                    //call generic reducer if result is defined
                    if (Object(_utils__WEBPACK_IMPORTED_MODULE_2__["isAssigned"])(effectResult)) {
                      dispatch[model.name].genericReducer(effectResult); //Return value of effects removed for the name of redux pattern
                      //return effectResult;
                    }

                    _context.next = 15;
                    break;

                  case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](5);
                    Object(_errorHandler__WEBPACK_IMPORTED_MODULE_3__["errorHandler"])({
                      name: model.name,
                      action: effectName,
                      error: _context.t0
                    });

                  case 15:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[5, 12]]);
          }));
        });
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/errorsPlugin.js":
/*!*****************************************************!*\
  !*** ./src/framework/state/plugins/errorsPlugin.js ***!
  \*****************************************************/
/*! exports provided: errorsPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorsPlugin", function() { return errorsPlugin; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");
/* harmony import */ var _isBuiltInModel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../isBuiltInModel */ "./src/framework/state/isBuiltInModel.js");





var initialStateOfErrors = {
  all: [],
  effects: {},
  models: {}
};
var errorsModel = {
  name: _config__WEBPACK_IMPORTED_MODULE_3__["constants"].models.ERROR_MODEL_NAME,
  reducers: {
    add: function add(state, _ref) {
      var name = _ref.name,
          action = _ref.action,
          error = _ref.error;
      return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state, {
        all: _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(state.all).concat([error]),
        models: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state.models, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, name, error)),
        effects: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state.effects, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, name, _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state.effects[name], _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, action, error))))
      });
    },
    remove: function remove(state, _ref2) {
      var name = _ref2.name,
          action = _ref2.action;
      var modelEffects = Object.keys(state.effects[name] || {}).filter(function (effectName) {
        return effectName !== action;
      }).reduce(function (acc, effectName) {
        acc[effectName] = state.effects[name][effectName];
        return acc;
      }, {});
      return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state, {
        models: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state.models, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, name, null)),
        effects: _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, state.effects, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, name, _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_2___default()({}, modelEffects)))
      });
    },
    removeAll: function removeAll() {
      return initialStateOfErrors;
    }
  },
  state: {
    all: [],
    effects: {},
    models: {}
  }
};
var errorsPlugin = {
  config: {
    models: {
      errorsModel: errorsModel
    }
  },
  init: function init(_ref3) {
    var dispatch = _ref3.dispatch;
    return {
      onModel: function onModel(_ref4) {
        var name = _ref4.name;
        if (Object(_isBuiltInModel__WEBPACK_IMPORTED_MODULE_4__["default"])(name)) return; //set initial state of erros model

        var modelActions = dispatch[name];
        errorsModel.state.effects[name] = {};
        initialStateOfErrors.effects[name] = {};
        initialStateOfErrors.models[name] = null; // map over effects within models

        Object.keys(modelActions).forEach(function (action) {
          if (dispatch[name][action].isEffect !== true) {
            return;
          }

          errorsModel.state.effects[name][action] = null;
          initialStateOfErrors.effects[name][action] = null;
        });
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/globalsPlugin.js":
/*!******************************************************!*\
  !*** ./src/framework/state/plugins/globalsPlugin.js ***!
  \******************************************************/
/*! exports provided: globalsPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalsPlugin", function() { return globalsPlugin; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");


var globals = {
  name: _config__WEBPACK_IMPORTED_MODULE_1__["constants"].models.GLOBALS_MODEL_NAME,
  reducers: {
    add: function add(state, action) {
      return _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({}, state, action);
    }
  },
  state: {
    permissions: {}
  }
};
var globalsPlugin = {
  config: {
    models: {
      globals: globals
    }
  },
  init: function init() {
    return {
      onStoreCreated: function onStoreCreated() {
        globals.state.permissions = _config__WEBPACK_IMPORTED_MODULE_1__["config"].get("oauth.permissions");
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/index.js":
/*!**********************************************!*\
  !*** ./src/framework/state/plugins/index.js ***!
  \**********************************************/
/*! exports provided: plugins */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugins", function() { return plugins; });
/* harmony import */ var _effectWrapperPlugin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./effectWrapperPlugin */ "./src/framework/state/plugins/effectWrapperPlugin.js");
/* harmony import */ var _effectHelperPlugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./effectHelperPlugin */ "./src/framework/state/plugins/effectHelperPlugin.js");
/* harmony import */ var _storeCreatedPlugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./storeCreatedPlugin */ "./src/framework/state/plugins/storeCreatedPlugin.js");
/* harmony import */ var _routerMiddlewarePlugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./routerMiddlewarePlugin */ "./src/framework/state/plugins/routerMiddlewarePlugin.js");
/* harmony import */ var _domainTasksPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./domainTasksPlugin */ "./src/framework/state/plugins/domainTasksPlugin.js");
/* harmony import */ var _globalsPlugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./globalsPlugin */ "./src/framework/state/plugins/globalsPlugin.js");
/* harmony import */ var _signalrMiddlewarePlugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./signalrMiddlewarePlugin */ "./src/framework/state/plugins/signalrMiddlewarePlugin.js");
/* harmony import */ var _errorsPlugin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./errorsPlugin */ "./src/framework/state/plugins/errorsPlugin.js");








var plugins = [_effectWrapperPlugin__WEBPACK_IMPORTED_MODULE_0__["effectWrapperPlugin"], _effectHelperPlugin__WEBPACK_IMPORTED_MODULE_1__["effectHelperPlugin"], _storeCreatedPlugin__WEBPACK_IMPORTED_MODULE_2__["storeCreatedPlugin"], _routerMiddlewarePlugin__WEBPACK_IMPORTED_MODULE_3__["routerMiddlewarePlugin"], _domainTasksPlugin__WEBPACK_IMPORTED_MODULE_4__["domainTasksPlugin"], _globalsPlugin__WEBPACK_IMPORTED_MODULE_5__["globalsPlugin"], _signalrMiddlewarePlugin__WEBPACK_IMPORTED_MODULE_6__["signalRMiddlewarePlugin"], _errorsPlugin__WEBPACK_IMPORTED_MODULE_7__["errorsPlugin"]];

/***/ }),

/***/ "./src/framework/state/plugins/persistPlugin.js":
/*!******************************************************!*\
  !*** ./src/framework/state/plugins/persistPlugin.js ***!
  \******************************************************/
/*! exports provided: getPersistor, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPersistor", function() { return getPersistor; });
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread */ "@babel/runtime/helpers/objectSpread");
/* harmony import */ var _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! redux-persist */ "redux-persist");
/* harmony import */ var redux_persist__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_persist__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! redux-persist/lib/storage */ "redux-persist/lib/storage");
/* harmony import */ var redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_2__);



var persistor; // persistor is used for PersistGate
// see https://github.com/rt2zz/redux-persist/blob/master/docs/PersistGate.md

var getPersistor = function getPersistor() {
  return persistor;
}; // rematch plugin

var persistPlugin = function persistPlugin() {
  var persistConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var persistStoreConfig = arguments.length > 1 ? arguments[1] : undefined;
  var callback = arguments.length > 2 ? arguments[2] : undefined;

  // merge config with common config options
  var mergedConfig = _babel_runtime_helpers_objectSpread__WEBPACK_IMPORTED_MODULE_0___default()({
    key: "root",
    storage: redux_persist_lib_storage__WEBPACK_IMPORTED_MODULE_2___default.a
  }, persistConfig);

  return {
    config: {
      // pass in merged config as first param of persistCombineReducers
      redux: {
        combineReducers: redux_persist__WEBPACK_IMPORTED_MODULE_1__["persistCombineReducers"].bind(null, mergedConfig)
      }
    },
    init: function init() {
      return {
        onStoreCreated: function onStoreCreated(store) {
          // run persist store once store is available
          persistor = Object(redux_persist__WEBPACK_IMPORTED_MODULE_1__["persistStore"])(store, persistStoreConfig, callback);
        }
      };
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (persistPlugin);

/***/ }),

/***/ "./src/framework/state/plugins/responsivePlugin.js":
/*!*********************************************************!*\
  !*** ./src/framework/state/plugins/responsivePlugin.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var redux_responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! redux-responsive */ "redux-responsive");
/* harmony import */ var redux_responsive__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_responsive__WEBPACK_IMPORTED_MODULE_0__);

var DEFAULT_BREAKPOINTS = {
  extraSmall: 480,
  small: 576,
  medium: 768,
  large: 1200,
  extraLarge: 1600
};

var responsivePlugin = function responsivePlugin(breakpoints) {
  return {
    config: {
      redux: {
        reducers: {
          browser: Object(redux_responsive__WEBPACK_IMPORTED_MODULE_0__["createResponsiveStateReducer"])(Object.assign(DEFAULT_BREAKPOINTS, breakpoints))
        },
        enhancers: [redux_responsive__WEBPACK_IMPORTED_MODULE_0__["responsiveStoreEnhancer"]]
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (responsivePlugin);

/***/ }),

/***/ "./src/framework/state/plugins/routerMiddlewarePlugin.js":
/*!***************************************************************!*\
  !*** ./src/framework/state/plugins/routerMiddlewarePlugin.js ***!
  \***************************************************************/
/*! exports provided: routerMiddlewarePlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routerMiddlewarePlugin", function() { return routerMiddlewarePlugin; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../routing */ "./src/framework/routing/index.js");


var routerMiddlewarePlugin = {
  config: {
    redux: {
      reducers: _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _routing__WEBPACK_IMPORTED_MODULE_1__["ROUTING_STORE_NAME"], _routing__WEBPACK_IMPORTED_MODULE_1__["routerReducer"])
    }
  },
  init: function init() {
    return {
      middleware: Object(_routing__WEBPACK_IMPORTED_MODULE_1__["routerMiddleware"])(Object(_routing__WEBPACK_IMPORTED_MODULE_1__["getHistory"])())
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/signalrMiddlewarePlugin.js":
/*!****************************************************************!*\
  !*** ./src/framework/state/plugins/signalrMiddlewarePlugin.js ***!
  \****************************************************************/
/*! exports provided: signalRMiddlewarePlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signalRMiddlewarePlugin", function() { return signalRMiddlewarePlugin; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _signalr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../signalr */ "./src/framework/signalr/index.js");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../config */ "./src/framework/config/index.js");




var signalRMiddlewarePlugin = {
  expose: {
    invokers: {},
    hubs: {}
  },
  init: function init(_ref) {
    var invokers = _ref.invokers,
        hubs = _ref.hubs,
        dispatch = _ref.dispatch,
        createDispatcher = _ref.createDispatcher;
    return {
      onModel: function onModel(model) {
        dispatch[model.name].hubs = {};
        Object.keys(model.hubs || {}).forEach(function (hubName) {
          var hubOptions = model.hubs[hubName];
          dispatch[model.name].hubs[hubName] = {}; //hook connect & disconnect and methods

          ["connect", "disconnect"].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(hubOptions.methods || [])).forEach(function (action) {
            dispatch[model.name].hubs[hubName][action] = createDispatcher(model.name, "".concat(hubName, "/").concat(action));

            switch (action) {
              case "connect":
                invokers["".concat(model.name, "/").concat(hubName, "/connect")] = function () {
                  var url = _config__WEBPACK_IMPORTED_MODULE_3__["config"].get("signalr.url");
                  if (!url) return;
                  hubs[model.name] = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, hubName, new _signalr__WEBPACK_IMPORTED_MODULE_2__["Hub"](Object.assign(hubOptions, {
                    url: "".concat(url, "/").concat(hubName),
                    context: dispatch[model.name],
                    autoConnect: true,
                    logging: "development" !== "production"
                  })));
                };

                break;

              case "disconnect":
                invokers["".concat(model.name, "/").concat(hubName, "/disconnect")] = function () {
                  hubs[model.name][hubName]["disconnect"]();
                };

                break;

              default:
                invokers["".concat(model.name, "/").concat(hubName, "/").concat(action)] = function () {
                  var _hubs$model$name$hubN;

                  (_hubs$model$name$hubN = hubs[model.name][hubName]["methods"])[action].apply(_hubs$model$name$hubN, arguments);
                };

            }
          });
        });
      },
      middleware: function middleware() {
        return function (next) {
          return function (action) {
            if (action.type in invokers) {
              invokers[action.type](action.payload);
            }

            return next(action);
          };
        };
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/plugins/storeCreatedPlugin.js":
/*!***********************************************************!*\
  !*** ./src/framework/state/plugins/storeCreatedPlugin.js ***!
  \***********************************************************/
/*! exports provided: storeCreatedPlugin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeCreatedPlugin", function() { return storeCreatedPlugin; });
/* harmony import */ var _registerModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../registerModel */ "./src/framework/state/registerModel.js");

/**
 * Effect async helpers plugin
 */

var storeCreatedPlugin = {
  init: function init() {
    return {
      onStoreCreated: function onStoreCreated(store) {
        store && Object(_registerModel__WEBPACK_IMPORTED_MODULE_0__["setStoreCreated"])();
      }
    };
  }
};

/***/ }),

/***/ "./src/framework/state/registerModel.js":
/*!**********************************************!*\
  !*** ./src/framework/state/registerModel.js ***!
  \**********************************************/
/*! exports provided: setStoreCreated, getGlobalModels, addGlobalModel, registerModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStoreCreated", function() { return setStoreCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGlobalModels", function() { return getGlobalModels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addGlobalModel", function() { return addGlobalModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerModel", function() { return registerModel; });
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @rematch/core */ "@rematch/core");
/* harmony import */ var _rematch_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_rematch_core__WEBPACK_IMPORTED_MODULE_0__);

var globalModels = [];
var isStoreCreated;
/**
 * Set true after store created (set by storeCreatedPlugin.js)
 */

var setStoreCreated = function setStoreCreated() {
  return isStoreCreated = true;
};
/**
 * Returns global models
 */

var getGlobalModels = function getGlobalModels() {
  return globalModels.reduce(function (result, model) {
    result[model.name] = model;
    return result;
  }, {});
};
/**
 * Append new model to global list
 *
 * @param {*} model Rematch Model
 */

var addGlobalModel = function addGlobalModel() {
  globalModels.push.apply(globalModels, arguments);
};
/**
 * Register model depending on store creation (lazy or immidate register)
 *
 * @param {*} model Rematch model
 */

var registerModel = function registerModel(model) {
  isStoreCreated ? Object(_rematch_core__WEBPACK_IMPORTED_MODULE_0__["model"])(model) : addGlobalModel(model);
};

/***/ }),

/***/ "./src/framework/utils/async.js":
/*!**************************************!*\
  !*** ./src/framework/utils/async.js ***!
  \**************************************/
/*! exports provided: reject, resolve */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return reject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolve", function() { return resolve; });
/**
 * Rejected promise
 *
 * @param {string} reason Rejeted reason
 * @returns {Promise.<string>} Rejected promise
 */
var reject = function reject(reason) {
  return Promise.reject(reason);
};
/**
 * Resolved promise
 *
 * @param {*} data Any payload
 * @returns {Promise.<*>} Retures resolved promise
 */


var resolve = function resolve(data) {
  return Promise.resolve(data);
};



/***/ }),

/***/ "./src/framework/utils/common.js":
/*!***************************************!*\
  !*** ./src/framework/utils/common.js ***!
  \***************************************/
/*! exports provided: isString, isNumber, isArray, isAssigned, isObject, isFunction, isEmptyObject, uuidv4, getHost, pipe, validate, merge, interpolate, updateQueryString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAssigned", function() { return isAssigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyObject", function() { return isEmptyObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uuidv4", function() { return uuidv4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHost", function() { return getHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateQueryString", function() { return updateQueryString; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "@babel/runtime/helpers/typeof");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid_v4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! uuid-v4 */ "uuid-v4");
/* harmony import */ var uuid_v4__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(uuid_v4__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/merge */ "lodash/merge");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Check given value is string
 *
 * @param {*} value Any value
 * @returns {boolean} Return true if value is string
 */

var isString = function isString(value) {
  return isAssigned(value) && typeof value === "string";
};
/**
 * Check given value is number
 *
 * @param {*} value Any value
 * @returns {boolean} Return true if value is number
 */


var isNumber = function isNumber(value) {
  return isAssigned(value) && typeof value === "number";
};
/**
 * Check given value is array
 *
 * @param {*} value Any value
 * @returns {boolean} Return true if value is array
 */


var isArray = function isArray(value) {
  return Array.isArray(value);
};
/**
 * Check given value is object
 *
 * @param {*} value Any value
 * @returns {boolean} Return true if value is object
 */


var isObject = function isObject(value) {
  return isAssigned(value) && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === "object";
};
/**
 * Check given value is truty
 *
 * @param {*} value Any value
 *
 * @returns {boolean} True id given value is falsy
 */


var isAssigned = function isAssigned(value) {
  return [undefined, null].indexOf(value) === -1;
};
/**
 * Chech given value is function
 *
 * @param {*} value Any value
 * @returns {boolean} Returns true if value is function
 */


var isFunction = function isFunction(value) {
  return isAssigned(value) && typeof value === "function";
};
/**
 * Chech given value is empty literal object
 *
 * @param {*} value Any value
 * @returns {boolean} Returns true if value is empty object
 */


var isEmptyObject = function isEmptyObject(value) {
  return isAssigned(value) && Object.keys(value).length === 0 && value.constructor === Object;
};
/**
 * Merge two or more object with deep coping
 *
 * @returns {string} Returns merged obj
 */


var merge = function merge() {
  return lodash_merge__WEBPACK_IMPORTED_MODULE_2___default.a.apply(void 0, arguments);
};
/**
 * Generate GUID
 * https://stackoverflow.com/a/2117523
 *
 * @returns {string} Returns GUID
 */


var uuidv4 = function uuidv4() {
  return uuid_v4__WEBPACK_IMPORTED_MODULE_1___default()();
};
/**
 * Get Host Url
 *
 * @returns {string} Returns Host url
 */


var getHost = function getHost() {
  if (typeof window === "undefined") return "";
  return window.location.protocol + "//" + window.location.host;
};
/**
 *
 * @param {...*} fns Factory functions
 */


var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (y, f) {
      return f(y);
    }, x);
  };
};
/**
 * Validate
 *
 * takes an array of arrays of validations and
 * throws if an error occurs
 */

/**
 * Validate
 * 
 * @description takes an array of arrays of validations and throws if an error occurs
 * @param {[]*} validations Validations array
 * 
 * @example
 *  validate([
      [
        config.plugins && !Array.isArray(config.plugins),
        'init config.plugins must be an array',
      ],
      [
        config.models && isObject(config.models),
        'init config.models must be an object',
      ]);
 */


var validate = function validate(validations) {
  if (true) {
    validations.forEach(function (validation) {
      var condition = validation[0];
      var errorMessage = validation[1];

      if (condition) {
        throw new Error(errorMessage);
      }
    });
  }
};
/**
 * Interpolate string with given tags
 *
 * @param {String} source Source string to interpolate
 * @param {Object|Array} tags Tags
 */


var interpolate = function interpolate(source, tags) {
  return source.replace(/{([^{}]*)}/g, function (a, b) {
    var r = tags[b];
    return typeof r === "string" || typeof r === "number" ? r : a;
  });
};
/**
 * Update source url with given querystrings
 *
 * @param {string} uri Base Uri
 * @param {Object} queryStrings QueryString
 */


var updateQueryString = function updateQueryString(uri, queryStrings) {
  var result = uri;

  for (var key in queryStrings) {
    if (queryStrings.hasOwnProperty(key)) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = result.indexOf("?") !== -1 ? "&" : "?";

      if (result.match(re)) {
        result = result.replace(re, "$1" + key + "=" + queryStrings[key] + "$2");
      } else {
        result = result + separator + key + "=" + queryStrings[key];
      }
    }
  }

  return result;
};



/***/ }),

/***/ "./src/framework/utils/index.js":
/*!**************************************!*\
  !*** ./src/framework/utils/index.js ***!
  \**************************************/
/*! exports provided: isString, isNumber, isArray, isAssigned, isObject, isFunction, isEmptyObject, uuidv4, getHost, pipe, validate, merge, interpolate, updateQueryString, addTrailingSlash, getObj, setObj, reject, resolve */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common */ "./src/framework/utils/common.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isString"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isNumber"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isArray"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isAssigned", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isAssigned"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isFunction"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isEmptyObject", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["isEmptyObject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "uuidv4", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["uuidv4"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getHost", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["getHost"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pipe", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["pipe"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["validate"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["merge"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["interpolate"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "updateQueryString", function() { return _common__WEBPACK_IMPORTED_MODULE_0__["updateQueryString"]; });

/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./string */ "./src/framework/utils/string.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "addTrailingSlash", function() { return _string__WEBPACK_IMPORTED_MODULE_1__["addTrailingSlash"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getObj", function() { return _string__WEBPACK_IMPORTED_MODULE_1__["getObj"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setObj", function() { return _string__WEBPACK_IMPORTED_MODULE_1__["setObj"]; });

/* harmony import */ var _async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./async */ "./src/framework/utils/async.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["reject"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "resolve", function() { return _async__WEBPACK_IMPORTED_MODULE_2__["resolve"]; });





/***/ }),

/***/ "./src/framework/utils/string.js":
/*!***************************************!*\
  !*** ./src/framework/utils/string.js ***!
  \***************************************/
/*! exports provided: addTrailingSlash, getObj, setObj */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTrailingSlash", function() { return addTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObj", function() { return getObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObj", function() { return setObj; });
/**
 * Adds trailing slash at the end of the url
 *
 * @param {string} url Given url
 */
var addTrailingSlash = function addTrailingSlash(url) {
  var lastChar = url.substr(-1);

  if (lastChar != "/") {
    url = url + "/";
  }

  return url;
};
/**
 * Gives you an object of given key path
 *
 * @param {string} key Propery full key path
 * @param {*} obj Any object
 * @returns {*} Object
 */


var getObj = function getObj(key, obj) {
  return key.split(".").reduce(function (res, prop) {
    return res[prop];
  }, obj);
};
/**
 * Set value of prop of given key
 *
 * @param {string} key Propery full key path
 * @param {*} value Propery value
 * @param {*} obj Any object
 */


var setObj = function setObj(key, value, obj) {
  var keyArray = key.split(".");
  keyArray.reduce(function (res, prop, index) {
    if (index < keyArray.length - 1) return res[prop] || (res[prop] = {});
    res[prop] = value;
  }, obj);
};



/***/ }),

/***/ "@aspnet/signalr/dist/browser/signalr":
/*!*******************************************************!*\
  !*** external "@aspnet/signalr/dist/browser/signalr" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@aspnet/signalr/dist/browser/signalr");

/***/ }),

/***/ "@babel/runtime/helpers/assertThisInitialized":
/*!***************************************************************!*\
  !*** external "@babel/runtime/helpers/assertThisInitialized" ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ "@babel/runtime/helpers/asyncToGenerator":
/*!**********************************************************!*\
  !*** external "@babel/runtime/helpers/asyncToGenerator" ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ "@babel/runtime/helpers/classCallCheck":
/*!********************************************************!*\
  !*** external "@babel/runtime/helpers/classCallCheck" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ "@babel/runtime/helpers/createClass":
/*!*****************************************************!*\
  !*** external "@babel/runtime/helpers/createClass" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ "@babel/runtime/helpers/defineProperty":
/*!********************************************************!*\
  !*** external "@babel/runtime/helpers/defineProperty" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ "@babel/runtime/helpers/extends":
/*!*************************************************!*\
  !*** external "@babel/runtime/helpers/extends" ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ "@babel/runtime/helpers/getPrototypeOf":
/*!********************************************************!*\
  !*** external "@babel/runtime/helpers/getPrototypeOf" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),

/***/ "@babel/runtime/helpers/inherits":
/*!**************************************************!*\
  !*** external "@babel/runtime/helpers/inherits" ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),

/***/ "@babel/runtime/helpers/objectSpread":
/*!******************************************************!*\
  !*** external "@babel/runtime/helpers/objectSpread" ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectSpread");

/***/ }),

/***/ "@babel/runtime/helpers/objectWithoutProperties":
/*!*****************************************************************!*\
  !*** external "@babel/runtime/helpers/objectWithoutProperties" ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ "@babel/runtime/helpers/possibleConstructorReturn":
/*!*******************************************************************!*\
  !*** external "@babel/runtime/helpers/possibleConstructorReturn" ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),

/***/ "@babel/runtime/helpers/toConsumableArray":
/*!***********************************************************!*\
  !*** external "@babel/runtime/helpers/toConsumableArray" ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),

/***/ "@babel/runtime/helpers/typeof":
/*!************************************************!*\
  !*** external "@babel/runtime/helpers/typeof" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/typeof");

/***/ }),

/***/ "@babel/runtime/regenerator":
/*!*********************************************!*\
  !*** external "@babel/runtime/regenerator" ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ "@rematch/core":
/*!********************************!*\
  !*** external "@rematch/core" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@rematch/core");

/***/ }),

/***/ "@rematch/loading":
/*!***********************************!*\
  !*** external "@rematch/loading" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@rematch/loading");

/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),

/***/ "history":
/*!**************************!*\
  !*** external "history" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("history");

/***/ }),

/***/ "lodash/merge":
/*!*******************************!*\
  !*** external "lodash/merge" ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("lodash/merge");

/***/ }),

/***/ "prop-types":
/*!*****************************!*\
  !*** external "prop-types" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom/server":
/*!***********************************!*\
  !*** external "react-dom/server" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dom/server");

/***/ }),

/***/ "react-loadable":
/*!*********************************!*\
  !*** external "react-loadable" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-loadable");

/***/ }),

/***/ "react-router":
/*!*******************************!*\
  !*** external "react-router" ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-router");

/***/ }),

/***/ "redux-persist":
/*!********************************!*\
  !*** external "redux-persist" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("redux-persist");

/***/ }),

/***/ "redux-persist/lib/storage":
/*!********************************************!*\
  !*** external "redux-persist/lib/storage" ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("redux-persist/lib/storage");

/***/ }),

/***/ "redux-responsive":
/*!***********************************!*\
  !*** external "redux-responsive" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("redux-responsive");

/***/ }),

/***/ "uuid-v4":
/*!**************************!*\
  !*** external "uuid-v4" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("uuid-v4");

/***/ })

/******/ });
});